import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';
import { B2BLoginResponseUserObject } from 'store/reducers/auth/authReducer.types';
import { DataDashboardTierEnum } from 'types/graphql';

const getUser = (state: IGlobalReduxStore) => state.auth.user;

export const isDashboardTierNoneSelector = createSelector(getUser, (user) => {
  if (!user) return false;
  const tier = (user as B2BLoginResponseUserObject).data_dashboard_tier;
  return tier === DataDashboardTierEnum.none;
});
